import React from "react";

const YouTubeIcon = props => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>youtube</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g
      id="youtube"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="iconmonstr-youtube-1"
        transform="translate(2.000000, 0.000000)"
        fill="#363636"
        fillRule="nonzero"
      >
        <path
          d="M2.652,0 L4.092,0 L5.08,3.702 L5.996,0 L7.45,0 L5.785,5.505 L5.785,9.262 L4.354,9.262 L4.354,5.505 L2.652,0 Z M9.246,2.373 C8.127,2.373 7.385,3.113 7.385,4.208 L7.385,7.557 C7.385,8.761 8.014,9.388 9.246,9.388 C10.268,9.388 11.072,8.705 11.072,7.557 L11.072,4.208 C11.072,3.139 10.275,2.373 9.246,2.373 Z M9.777,7.5 C9.777,7.872 9.587,8.146 9.245,8.146 C8.894,8.146 8.691,7.859 8.691,7.5 L8.691,4.321 C8.691,3.947 8.863,3.67 9.22,3.67 C9.61,3.67 9.777,3.939 9.777,4.321 L9.777,7.5 Z M14.506,2.43 L14.506,7.616 C14.351,7.81 14.006,8.128 13.759,8.128 C13.488,8.128 13.421,7.942 13.421,7.668 L13.421,2.43 L12.151,2.43 L12.151,8.14 C12.151,8.815 12.357,9.36 13.038,9.36 C13.422,9.36 13.956,9.16 14.506,8.507 L14.506,9.261 L15.776,9.261 L15.776,2.43 L14.506,2.43 Z M16.709,16.288 C16.261,16.288 16.168,16.603 16.168,17.051 L16.168,17.71 L17.2370079,17.71 L17.237,17.05 C17.238,16.61 17.145,16.288 16.709,16.288 Z M12.006,16.328 C11.922,16.371 11.839,16.437 11.756,16.526 L11.756,20.581 C11.855,20.687 11.95,20.763 12.043,20.81 C12.24,20.91 12.528,20.917 12.662,20.743 C12.732,20.651 12.767,20.502 12.767,20.294 L12.767,16.935 C12.767,16.715 12.724,16.549 12.638,16.435 C12.491,16.242 12.218,16.221 12.006,16.328 Z M16.833,11.133 C14.229,10.956 5.767,10.956 3.167,11.133 C0.353,11.325 0.021,13.025 -1.77635684e-15,17.5 C0.021,21.967 0.35,23.675 3.167,23.867 C5.767,24.044 14.229,24.044 16.833,23.867 C19.647,23.675 19.979,21.974 20,17.5 C19.979,13.033 19.65,11.325 16.833,11.133 Z M4.509,21.819 L3.146,21.819 L3.146,14.279 L1.736,14.279 L1.736,12.999 L5.918,12.999 L5.918,14.279 L4.508,14.279 L4.508,21.819 L4.509,21.819 Z M9.355,21.819 L8.145,21.819 L8.145,21.101 C7.922,21.366 7.69,21.568 7.449,21.706 C6.797,22.08 5.902,22.071 5.902,20.751 L5.902,15.313 L7.111,15.313 L7.111,20.301 C7.111,20.563 7.174,20.739 7.433,20.739 C7.669,20.739 7.997,20.436 8.144,20.252 L8.144,15.313 L9.354,15.313 L9.354,21.819 L9.355,21.819 Z M14.012,20.471 C14.012,21.276 13.711,21.902 12.906,21.902 C12.463,21.902 12.094,21.74 11.757,21.319 L11.757,21.819 L10.536,21.819 L10.536,12.999 L11.757,12.999 L11.757,15.839 C12.03,15.506 12.401,15.231 12.833,15.231 C13.719,15.231 14.013,15.98 14.013,16.862 L14.013,20.471 L14.012,20.471 Z M18.483,18.719 L16.169,18.719 L16.169,19.947 C16.169,20.435 16.211,20.857 16.697,20.857 C17.208,20.857 17.238,20.513 17.238,19.947 L17.238,19.495 L18.483,19.495 L18.483,19.984 C18.483,21.237 17.945,21.997 16.67,21.997 C15.515,21.997 14.924,21.155 14.924,19.984 L14.924,17.063 C14.924,15.934 15.67,15.149 16.761,15.149 C17.922,15.149 18.482,15.887 18.482,17.063 L18.482,18.719 L18.483,18.719 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

export default YouTubeIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/YouTubeIcon.js